(function () {
	const initSection = (sectionEl) => {
		if (!sectionEl) return;
			const imgSlideEl = sectionEl.querySelector(".js-img-slide");
			if (!imgSlideEl) return;

			// Clean up previous init for this specific section instance
			if (sectionEl.__imageTabsCleanup) {
				try {
					sectionEl.__imageTabsCleanup();
				} catch (e) {}
				sectionEl.__imageTabsCleanup = null;
			}

			const descriptionSlideEl = sectionEl.querySelector(".js-description-slide");
			const paginationEl = sectionEl.querySelector(".swiper-pagination");
			const effects = imgSlideEl.dataset.effects || "";

			const slideEffectsTabs = (fx) => {
				switch (fx) {
					case "slide-horizontal":
						return {};
					case "slide-vertical":
						return { direction: "vertical" };
					case "fade":
						return { effect: "fade", parallax: false };
					case "coverflow":
						return {
							effect: "coverflow",
							coverflowEffect: {
								rotate: 50,
								stretch: 0,
								depth: 100,
								modifier: 1,
								slideShadows: true,
							},
						};
					case "creative":
						return {
							effect: "creative",
							creativeEffect: {
								prev: { shadow: true, translate: [0, 0, -400] },
								next: { translate: ["100%", 0, 0] },
							},
						};
					case "flip":
						return { effect: "flip" };
					default:
						return {};
				}
			};

			const setThemeModeFromActiveSlide = () => {
				const themeModeEl = sectionEl.querySelector(".js-theme-mode");
				if (!themeModeEl) return;

				const activeSlide = sectionEl.querySelector(
					".js-img-slide .swiper-slide-active"
				);
				const isDark = activeSlide?.classList.contains("block-theme-mode-dark");

				themeModeEl.classList.toggle("section-theme-mode-dark", !!isDark);
				themeModeEl.classList.toggle("section-theme-mode-light", !isDark);
			};

			const imageTabsSwiper = new Swiper(imgSlideEl, {
				speed: 2200,
				...slideEffectsTabs(effects),
				allowTouchMove: false,
				pagination: paginationEl
					? {
							el: paginationEl,
							clickable: true,
						}
					: undefined,
				on: {
					init: setThemeModeFromActiveSlide,
					transitionStart: setThemeModeFromActiveSlide,
				},
			});

			let descriptionTabsSwiper = null;
			if (descriptionSlideEl) {
				descriptionTabsSwiper = new Swiper(descriptionSlideEl, {
					allowTouchMove: false,
					spaceBetween: 30,
					breakpoints: {
						1200: { spaceBetween: 0 },
					},
				});

				// If controller module is available, keep them in sync automatically.
				if (imageTabsSwiper.controller && descriptionTabsSwiper.controller) {
					imageTabsSwiper.controller.control = descriptionTabsSwiper;
					descriptionTabsSwiper.controller.control = imageTabsSwiper;
				}
			}

			const tabsEl = sectionEl.querySelector(".js-tabs");
			const tabItems = tabsEl ? Array.from(tabsEl.querySelectorAll(".tabs__item")) : [];

			const onTabMouseEnter = (evt) => {
				const li = evt.target?.closest?.(".tabs__item");
				if (!li || !tabsEl.contains(li)) return;
				const index = tabItems.indexOf(li);
				if (index < 0) return;

				const currentIndex = tabItems.findIndex((t) =>
					t.classList.contains("tabs__item--current")
				);
				if (index === currentIndex) return;

				tabItems.forEach((t) => t.classList.remove("tabs__item--current"));
				li.classList.add("tabs__item--current");

				imageTabsSwiper.slideTo(index);
				if (descriptionTabsSwiper) descriptionTabsSwiper.slideTo(index);
			};

			if (tabsEl && tabItems.length) {
				tabsEl.addEventListener("mouseover", onTabMouseEnter);
			}

			sectionEl.__imageTabsCleanup = () => {
				if (tabsEl) tabsEl.removeEventListener("mouseover", onTabMouseEnter);
				try {
					imgSlideEl.swiper?.destroy?.(true, true);
				} catch (e) {}
				try {
					descriptionSlideEl?.swiper?.destroy?.(true, true);
				} catch (e) {}
			};
	};

	const imageTabs = (root = document) => {
		const sections = root.querySelectorAll
			? root.querySelectorAll(".js-image-tabs")
			: [];
		if (!sections.length) return;
		sections.forEach(initSection);
	};

	document.addEventListener("DOMContentLoaded", function () {
		imageTabs();
		document.addEventListener("shopify:section:load", function (evt) {
			// Only initialize the section that was just added/reloaded
			imageTabs(evt?.target || document);
		});
	});
})();
